<template>
    <div class="login-container">
      <div class="login-box">
          <div class="login-title">车辆后台管理系统 - 欢迎登录</div>
          <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" class="login-form">
<!--              <el-form-item label="公司编码" prop="csn">-->
<!--                  <el-input v-model="loginForm.csn" placeholder="请输入公司编码" prefix-icon="el-icon-user" />-->
<!--              </el-form-item>-->
               <el-form-item prop="username" class="formStyle">
                  <el-input v-model="loginForm.username" placeholder="请输入账号" prefix-icon="el-icon-user" class="inputStyle" />
              </el-form-item>
              <el-form-item prop="password" class="formStyle">
                  <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-thumb" class="inputStyle" />
              </el-form-item>
                <el-form-item class="formStyle formEnd">
                      <el-button type="success" @click="login()" class="loginStyle">登录</el-button>
                      <el-button type="info" @click="resetPassword">重置密码</el-button>
                    <!--<el-button type="primary" @click="register">去注册</el-button>-->

                </el-form-item>
          </el-form>

      </div>
      <div class="login-box2"><i class="el-icon-truck"></i> 网站备案号：鲁ICP备2022039157号</div>
      <el-dialog
          title="重置密码"
          :visible.sync="resetPassDialog"
          width="600px"
          top="15%"
          :before-close="handleClose"
          :max-height="600"
          :auto-append-to-body="true"
          :append-to-body="true"
          style="overflow: auto"
      >

        <el-form :model="resetPForm" status-icon ref="resetFormRules" label-width="100px" class="demo-ruleForm" :rules="resetFormRules">
<!--          <el-form-item label="用户帐号" required prop="username">-->
<!--            <el-input type="text" v-model="resetPForm.username" autocomplete="off"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="手机号码" required prop="mobile">
            <el-input type="text" v-model="resetPForm.mobile" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机验证码" required prop="code">
            <el-input v-model.number="resetPForm.code" style="width: 30%"></el-input>
            <el-button type="warning" @click="sendMobile" :disabled="isSendDisabled">发送手机验证码</el-button>
              <span v-if="countdown > 0">
                  剩余<span class="redStyle">{{ countdown }}</span>秒后可重试
                  <i class="el-icon-time"></i>
              </span>
          </el-form-item>
          <el-form-item label="密码" required prop="password">
            <el-input type="password" v-model="resetPForm.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" required prop="rpassword">
            <el-input type="password" v-model="resetPForm.rpassword" autocomplete="off"></el-input>
          </el-form-item>

        </el-form>
        <el-row>
            <el-col :span="24":offset="10">
                <el-button type="info" @click="resetPassDialog = false">取 消</el-button>
                <el-button type="success" @click="resetPassSubmit">确 定</el-button>
            </el-col>
        </el-row>

      </el-dialog>
    </div>
</template>

<script>
import { hexMD5 } from '../utils/md5' //引入
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        csn:'ZS0001',
        username: '',
				password: '',
      },
      objArr:{},
      loginFormRules: {
        //验证规则
        csn: [
          { required: true, message: "请输入公司编码", trigger: "blur" }
        ],
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 15,
          //   message: "长度在 6 到 15 个字符",
          //   trigger: "blur",
          // },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 15,
          //   message: "长度在 6 到 15 个字符",
          //   trigger: "blur",
          // },
        ],
      },
      resetPassDialog:false,
      resetPForm:{
        'username':'',
        'mobile':'',
        'code':'',
        'password':'',
        'rpassword':'',
      },
      resetFormRules: {
        //验证规则
        // username: [
        //   { required: true, message: "请输入用户帐号", trigger: "blur" }
        // ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "只能输入11位手机号码",
          },
        ],
        code: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },

        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "长度在 6 到 15 个字符",
            trigger: "blur",
          },
        ],
        rpassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "长度在 6 到 15 个字符",
            trigger: "blur",
          },
        ],
      },
        isSendDisabled: false,
        sendTimestamp: null,
        countdown: 0, // 剩余秒数
    };
  },
  created(){
    if(this.$route.query.userData) {
      console.log('ces:',this.$route.query.userData)
      var userData = this.$route.query.userData;
      const oldStr = window.atob(userData);
      console.log('解密后字符串:',oldStr);
      let words = oldStr.split("&");
      if(words && words[0])
      {
        this.loginForm.username = words[0];
        this.loginForm.password = '111222';
        this.login();
      }

    }
  },
  mounted() {

  },
  methods: {

    //重置按钮
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields();
    },
    //登录按钮
    login() {
      //this.$refs.loginFormRef.validate((valid) => {
       // if (valid) {
          ////console.log(this.loginForm,99);
          let obj = {
						username: this.loginForm.username,
						password: hexMD5(this.loginForm.password),
						csn: "BX0001",
						appid:'20220101'
					}
          this.objArr = obj;
					obj.sign=this.sign(this.objArr);

          this.$axios.getAdmin(this.objArr).then(res=>{
            if (res.code == 200) {
                //sessionStorage.setItem("token", res.data.token);
                sessionStorage.setItem("remark", res.data.remark);
                sessionStorage.setItem('company_id', res.data.company_id);
                sessionStorage.setItem('employee_id', res.data.employee_id);
                sessionStorage.setItem('user_id', res.data.id);
                // window.localStorage.setItem("menu", res.data.menu);
                window.sessionStorage.setItem("userName", res.data.user_name);
                window.sessionStorage.setItem("name", res.data.name);
                sessionStorage.setItem("token", res.data.token);
                sessionStorage.setItem("company_role_id", res.data.company_role_id);
                sessionStorage.setItem("shopList",JSON.stringify(res.data.shopList));
                sessionStorage.setItem("login_ip", res.data.login_ip);
                sessionStorage.setItem("login_time", res.data.login_time);
                sessionStorage.setItem("last_login_ip", res.data.last_login_ip);
                sessionStorage.setItem("last_login_time", res.data.last_login_time);
                sessionStorage.setItem("role_name", res.data.role_name);
                sessionStorage.setItem("feePayInfo",JSON.stringify(res.data.feePayInfo));//净费支付账号信息
                //sessionStorage.setItem("feePayInfo",JSON.stringify(res.data.feePayInfo));//净费支付账号信息
                sessionStorage.setItem("source",res.data.source);//source
                ////console.log('departmentInfo:',res.data.departmentInfo);
                if(res.data.departmentInfo){
                  sessionStorage.setItem("link_name",res.data.departmentInfo.contact_name ? res.data.departmentInfo.contact_name :'');//净费支付账号信息
                  sessionStorage.setItem("link_tel",res.data.departmentInfo.mobile ? res.data.departmentInfo.mobile :'');
                }
                if(res.data.supervise){
                  sessionStorage.setItem("contact_name",res.data.supervise.contact_name ? res.data.supervise.contact_name :'');//净费支付账号信息
                  sessionStorage.setItem("contact_mobile",res.data.supervise.mobile ? res.data.supervise.mobile :'');
                }
                this.$message.success('登录成功');
                console.log('redirect:',this.$route.query.redirect);
                if (this.$route.query.redirect && this.$route.query.redirect!='/' ) { //如果存在参数
                  let redirect = this.$route.query.redirect
                  //this.$router.replace('/'+redirect)//则跳转至进入登录页前的路由
                  this.$router.go(-1)
                } else {
                  this.$router.push('/home')//否则跳转至首页
                }
              } else {
                this.$message.error(res.msg);
              }
          }).catch(error=>{
            ////console.log(error);
          })
        //}
      //});
    },
    sign(unordered){
        const secret="20230101";
				const ordered = {};
				Object.keys(unordered).sort().forEach(function(key) {
					if(!Array.isArray(unordered[key])){
					ordered[key] = unordered[key];
					}
				});
				var rs="";
				for(var key in ordered ){
					rs +=key+"="+ordered[key]+"&";
				}
				////console.log(rs+"key="+secret);
				return hexMD5(hexMD5(rs+"key="+secret)).toLocaleUpperCase();

			},
//重置密码open
    resetPassword(){
      this.resetPassDialog = true;
    },
    /*
    register(){
      this.$router.push("/register");
    },*/
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
    },
    resetPassSubmit(){
        // this.$message.error('功能暂未开放');
        // return false;
      console.log('resetPForm',this.resetPForm);
      this.$refs.resetFormRules.validate((valid) => {
        if (valid) {

          let obj = {
              password: this.resetPForm.password,
              repassword: this.resetPForm.rpassword,
              phone: this.resetPForm.mobile,
              smscode: this.resetPForm.code,
          }
          this.objArr = obj;
          // obj.sign=this.sign(this.objArr);
          this.$axios.rePassword(this.objArr).then(res=>{
            if (res.code == 200) {
              this.$message.success('重置密码成功');

              this.$router.push("/login");
            } else {
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }
      });
    },


      sendMobile() {
          if(this.resetPForm.mobile==''){
              this.$message.error('请输入手机号');
              return false;
          }
          if(!(/^1[3456789]\d{9}$/.test(this.resetPForm.mobile))){
              this.$message.error('手机号格式错误');
              return false;
          }
          if (this.isSendDisabled && Date.now() - this.sendTimestamp < 3 * 60 * 1000) {
              // 若仍在锁定时间内，提示用户并返回
              this.$message.error('请等待3分钟后重新发送验证码');
              return false;
          }
// 启动倒计时
          this.countdown = 180; // 初始值为3分钟（180秒）
          this.isSendDisabled = true;
          this.sendTimestamp = Date.now();

          this.countdownInterval = setInterval(() => {
              this.countdown -= 1;

              if (this.countdown <= 0) {
                  clearInterval(this.countdownInterval);
                  this.countdown = 0;
                  this.isSendDisabled = false;
              }
          }, 1000);


          this.sendVerificationCode(this.resetPForm.mobile)
              .then(() => {
                  // 发送成功，更新状态
                  this.isSendDisabled = true;
                  this.sendTimestamp = Date.now();
                  // this.$message.success('验证码已发送，请查收短信');
              })
              .catch((error) => {
                  // 发送失败，处理错误
                  this.$message.error(`发送验证码失败：${error.message}`);
              });
      },

      // 假设您已有此方法用于实际发送验证码
      async sendVerificationCode(mobile) {
          const param = {
              phone:mobile
          };
          // this.$message.success('发送短信验证码成功');
          this.$axios.getSmsSYSCode(param).then(res=>{
              if (res.code == 200) {
                  this.$message.success(res.msg);
              } else {
                  this.$message.error(res.msg);
              }
          }).catch(error=>{
              //console.log(error);
          })
      },
      //重置密码end
  },
};
</script>

<style lang="less" scoped>

.login-container{
    height: 100vh;
    background: url('https://zkycyd.oss-cn-beijing.aliyuncs.com/public/car/car.jpg') no-repeat center center;
    background-size: cover;
}
.login-box {
    position: absolute;
    top: 50%;
    right: 1%;
    transform: translate(-10%, -40%);
    width: 620px;
    //background-color: #fff;
    border: 1px solid #DCDFE6;
    border-radius: 8px;
    padding: 20px;
    // box-shadow: 0 0 20px #999;
    .login-title {
      font-size: 24px;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
      text-shadow: 4px 4px 3px rgba(0, 0, 0, 0.1);
      letter-spacing: 5px;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
      height: 120px;
      line-height: 120px;
    }
  }
.formStyle{
  text-align: center;
  height: 60px;
  line-height: 60px;
}
.inputStyle{
  width: 80%;
}
.loginStyle{
  border-color: #66b1ff;
}
.login-box2 {
  position: absolute;
  bottom: 1%;
  right: 1%;
  transform: translate(-10%, -40%);
  width: 620px;
  //background-color: #fff;
  //border: 1px solid #DCDFE6;
  //border-radius: 8px;
  font-size: 20px;
  color: #999999;
}
/deep/.el-dialog, .el-dialog__body{
  height: auto;
}
.redStyle{
  color: red;
}

</style>



// WEBPACK FOOTER //
// src/view/Login.vue